import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import { PromoTypeService } from '../../../services/index';

@Component({
    selector: 'add-edit-promo-type',
    templateUrl: './addEditPromoType.component.html'
})
export class AddEditPromoTypeComponent implements OnInit {

    @Output() promoTypeLoadEvent = new EventEmitter();

    public title: string;
    public userType: string;
    public promoTypeData: any = {};
    public isLoading: boolean = false;

    statusOptions = ['Active', 'Inactive'];

    constructor(
        public bsModalRef: BsModalRef,
        public toasterService: ToasterService,
        private promoTypeService: PromoTypeService
    ) { }

    ngOnInit(): void {
        if (this.promoTypeData.mode === 'Add') {
            this.promoTypeData.status = 'Active';
        }
    }

    onSave(): void {
        this.isLoading = true;

        let params = {
            mode: this.promoTypeData.mode,
            promo_type: this.promoTypeData.promo_type,
            status: this.promoTypeData.status
        };

        if (this.promoTypeData.mode === 'Edit') {
            params['promo_type_id'] = this.promoTypeData.promo_type_id;
        }

        this.promoTypeService
            .addUpdatePromoType(params)
            .then((res: any) => {
                this.isLoading = false;
                if (res && res.success) {
                    this.toasterService.pop({
                        type: 'success',
                        title: 'Success',
                        body: res.message
                    });
                    this.promoTypeLoadEvent.emit();
                    this.bsModalRef.hide();
                } else {
                    this.toasterService.pop({
                        type: 'error',
                        title: 'Error',
                        body: res.message || 'Something went wrong'
                    });
                }
            })
            .catch(() => {
                this.isLoading = false;
                this.toasterService.pop({
                    type: 'error',
                    title: 'Error',
                    body: 'Something went wrong'
                });
            });
    }
}


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/promoType/addEditPromoType.component.ts